import { withChartLayout } from 'components/common';
import MoodDisorderQuestionnaire from 'components/features/chart/special-charts/mood-disorder-questionnaire/MoodDisorderQuestionnaire';

const MoodDisorderQuestionnairePage = withChartLayout('Mood Disorder Questionnaire')(MoodDisorderQuestionnaire);
export default MoodDisorderQuestionnairePage;
